<template>
  <article v-if="user" class="group-row">
    <div v-if="user.user">
      <Icon
        v-if="user.user && user.user.type"
        :id="user.user.type"
        :scale="0.8"
        class="mrgh-- "
      />
      {{ user.user.label }}
    </div>

    <aside>
      <time
        v-if="user.start_datetime"
        :datetime="user.start_datetime"
        class="group-row__time"
      >
        <span v-if="!user.end_datetime" class="text-small text-alt">
          {{ $t('planification.groups.fields.start-datetime.label') }}
        </span>
        {{ user.start_datetime && formatDate(user.start_datetime) }}
      </time>

      <time
        v-if="user.end_datetime"
        :datetime="user.end_datetime"
        class="group-row__time"
      >
        <span v-if="!user.start_datetime" class="text-small text-alt">
          {{ $t('planification.groups.fields.end-datetime.label') }}
        </span>
        {{ user.end_datetime && formatDate(user.end_datetime) }}
      </time>
    </aside>

    <ListInline class="justify-content-end">
      <li class="group-row__action">
        <Btn variant="link" class="pdgh0" @click="toggleUpdate">
          <Icon id="edit" :scale="0.6" />
          {{ $t('common.edit') }}
        </Btn>
      </li>
      <li class="group-row__action">
        <Btn variant="link" class="pdgh0" @click="toggleDelete">
          <Icon id="trash" :scale="0.6" />
          {{ $t('common.delete') }}
        </Btn>
      </li>
    </ListInline>
  </article>
</template>

<script>
import eventBus from '@/eventBus';
import { formatDate } from '@/helpers/dates';

export default {
  props: {
    group: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },

  methods: {
    formatDate(date) {
      return formatDate(date, 'dd.MM.yyyy HH:mm');
    },

    toggleUpdate() {
      eventBus.$emit('togglePlanificationUserAddOrUpdate', {
        group: this.group,
        user: this.user,
      });
    },

    toggleDelete() {
      eventBus.$emit('togglePlanificationUserDelete', {
        group: this.group,
        user: this.user,
      });
    },
  },
};
</script>
